export default __webpack_public_path__ + "static/media/fir_trees_landscape.1d574004.jpg";